import { createAction } from "@reduxjs/toolkit";
import axios from 'apis';
import { asyncThunkWrapper } from "helpers/asyncThunkWrapper";

const attributes = [
  'id', 
  { input: ['id', 'filename'] }, 
  {fill_template: ['id', { template: [ 'id', 'name'] }]}, 
  'status', 
  'updated_at'
];
const fullAttributes = [
  'id',
  { input: ['id', 'filename', 'content_type', 'url'] }, 
  { result: ['id', 'filename', 'content_type', 'url'] }, 
  'status', 
  'updated_at'
];

export const getFillAnalyses = asyncThunkWrapper({ 
  model: 'fillAnalyses', 
  action: 'getFillAnalyses', 
  func: async ({ offset = 0 }) => {
    const params = { limit: 25, offset, orders: { updated_at: 'desc' }, attributes };
    const response = await axios.get('/fill_flow/fill_analyses', { params });

    return response.data;
  } 
});
export const getFillAnalysis = asyncThunkWrapper({ 
  model: 'fillAnalyses', 
  action: 'getFillAnalysis', 
  func: async ({ id, cable = false }) => {
    const params = { attributes: fullAttributes };
    const response = await axios.get(`/fill_analyses/${id}`, { params });
      
    return { data: response.data, cable };
  } 
});
export const createFillAnalysis = asyncThunkWrapper({ 
  model: 'fillAnalyses', 
  action: 'createFillAnalysis', 
  func: async (fill_analysis) => {
    const response = await axios.post(`/fill_flow/fill_analyses`, { fill_analysis, attributes });

    return response.data;
  } 
});
export const clearLocalFillAnalyses = createAction('fillAnalyses/clearLocalFillAnalyses');
export const clearLocalActiveFillAnalysis = createAction('fillAnalyses/clearLocalActiveFillAnalysis');